import React, { useEffect, useRef } from "react";
// Displays HTML content raw.  Use with caution.
//
/**
 * Component that renders raw HTML into the DOM and ensures that external links open in a new tab/window
 * This component is `styled` compatible
 * @param {object} props
 * @param {string} props.html -- HTML string that is set via dangerouslySetInnerHTML
 * @param {string} props.className -- prop used by the `styled` library to do its magic
 */
function HtmlLinkContent({ html, className }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const links = Array.from(ref.current.querySelectorAll("a"));
    links.forEach(
      (link) => {
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin) {
          // external link
          link.setAttribute("target", "_blank");
          link.setAttribute("rel", "noopener noreferrer");
        }
      },
      [html],
    );
  });

  return <div className={className} ref={ref} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default HtmlLinkContent;
